export default "__VITE_ASSET__32257333__"